import { useMemo } from 'react';
import { InitValues, SelectedOrgUnit } from './types';
import { useAuth } from 'src/state/auth';
import { Role } from 'src/graphql/_generated';

type Member = SelectedOrgUnit['member'];

type UseInitialValues = (params: { member?: Member; isReady: boolean }) => {
  initError: string;
  initialValues: InitValues;
};

const useInitialValues: UseInitialValues = ({ member, isReady }) => {
  const { profile } = useAuth();

  return useMemo(() => {
    if (!profile || !isReady) {
      return {
        initError: '',
        initialValues: {
          name: '',
          email: '',
        },
      };
    }

    // GLOBAL SELF - use profile data
    if (!member) {
      return {
        initError: '',
        initialValues: {
          name: profile.user.name,
          profilePhotoPath: profile.user.profilePhotoPath,
          email: profile.user.email,
          defaultName: profile.user.name,
          receiveNotifications: !!profile.user.receiveNotifications,
        },
      };
    }

    const association = member.association;

    if (association) {
      return {
        initError: '',
        initialValues: {
          name: association.userName || '',
          profilePhotoPath: member.user?.profilePhotoPath || null,
          email: association.userEmail || '',
          defaultName: association.userName || '',
          acceptedDate: association.acceptedDate,
          receiveNotifications: association.notifications,
          role: association.role || Role.Collaborator,
        },
      };
    }

    return {
      initError: 'User not found',
      initialValues: {
        name: member.user?.name || '',
        defaultName: member.user?.name || '',
        profilePhotoPath: member.user?.profilePhotoPath || null,
        email: member.user?.email || '',
      },
    };
  }, [member, profile, isReady]);
};

export default useInitialValues;
